const Pricing = {
  label: 'Pricing',
  url: '/pricing',
  heapClass: 'ie_topnav_pricing'
}

export default Pricing
